<template>
  <b-container>
    <communicating-tables-lists
      :brick_id="brick_id"
      :rhs_title="$t('list_chosen_hstack_tables')"
      :all_tables="tables_undeleted"
      :rhs_elements="hstacked_tables"
      :element_constructor="rhs_table_structure"
      :disabled="changes_disabled"
      @input="maj($event)"
    >
      <template v-slot:rhs_table_component="slot_props">
        <b-form-group :disabled="slot_props.disabled">
          <b-list-group-item>
            <div class="table-handle hand-pointer">
              <span class="fas fa-grip-vertical fa-fw" />
              {{ slot_props.element_name }}
            </div>
            <hr class="chosen_table_separator" />

            <b-form-group>
              <b>
                {{ $t('columns_extension_type') }}
              </b>
              <b-form-radio
                v-model="slot_props.element.extension_type"
                value="no_extension"
              >
                {{ $t('no_extension') }}
              </b-form-radio>
              <b-form-radio
                v-model="slot_props.element.extension_type"
                value="prefix"
              >
                {{ $t('prefix') }}
              </b-form-radio>
              <b-form-radio
                v-model="slot_props.element.extension_type"
                value="suffix"
              >
                {{ $t('suffix') }}
              </b-form-radio>
            </b-form-group>

            <b-form-group
              v-if="slot_props.element.extension_type !== 'no_extension'"
            >
              <slot name="label">
                {{ $t('extension_colname_choice') }}
                <span
                  v-c-tooltip="$t('extension_colname_choice_tooltip')"
                  class="fas fa-question-circle"
                ></span>
              </slot>
              <b-form-input
                v-model="slot_props.element.name_extension"
                type="text"
                :placeholder="$t('wanted_extension')"
              />
            </b-form-group>
          </b-list-group-item>
        </b-form-group>
      </template>
    </communicating-tables-lists>
  </b-container>
</template>

<i18n>
{
  "en": {
    "list_chosen_hstack_tables": "List of chosen tables for hstack",
    "columns_extension_type": "Column extension type",
    "no_extension": "No Extension",
    "prefix": "Prefix",
    "suffix": "Suffix",
    "extension_colname_choice": "Choice of colname extension",
    "extension_colname_choice_tooltip": "The entered extension will be added in front of, or at the end, of the name of every column of this table, according to the choice of prefix or suffix",
    "wanted_extension": "Enter the wanted extension"
  },
  "fr": {
    "list_chosen_hstack_tables": "Liste des tables choisies pour le hstack",
    "columns_extension_type": "Type d'extension des noms de colonnes",
    "no_extension": "Aucune",
    "prefix": "Préfixe",
    "suffix": "Suffixe",
    "extension_colname_choice": "Choix de l'extension des noms de colonnes",
    "extension_colname_choice_tooltip": "L'extension entrée sera juxtaposée devant ou derrière le nom de chacune des colonnes de cette table, suivant le choix préfixe ou suffixe effectué",
    "wanted_extension": "Entrez l'extension voulue"
  }
}

</i18n>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { HstackTableInfoEntity } from '@/components/object_model.js'

// import { subscription_mixin, brick_mixin } from '@/components/mixin.js'
import { global_brick_mixin } from '@/components/mixin.js'
import CommunicatingTablesLists from '@/components/communicating_tables_lists.vue'

// *****************************************************************************

export default {
  name: 'BrickHstack',
  components: {
    CommunicatingTablesLists,
  },
  // mixins: [subscription_mixin, brick_mixin],
  mixins: [global_brick_mixin],
  // props: [
  //   'brick_id',
  //   'project_id',
  //   'description_name',
  //   'metavariables_dicts_poids',
  // ],
  data() {
    return {
      rhs_table_structure: HstackTableInfoEntity,
      hstacked_tables: [],
    }
  },
  computed: {
    adapted_data() {
      let adapted = {
        uid: this.brick_id,
        parents_info: this.hstacked_tables,
      }

      _.assignIn(adapted, this.description_name)

      return adapted
    },
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(nv) {
        let cur_hstacked_tables = this.cur_brick.parents_info
        if (!_.isEqual(cur_hstacked_tables, this.hstacked_tables)) {
          this.hstacked_tables = _.cloneDeep(cur_hstacked_tables)
        }
      },
    },
  },
  methods: {
    maj(event) {
      this.hstacked_tables = _.cloneDeep(event)
    },
  },
}
</script>
